// Shared by Next's Node config loader and browser/server application code.
const EU_WTW_NOVA_HOSTNAMES = ['eu-nova.wtwco.com', 'nova-eu.wtwco.com', 'stage-eu-nova.wtwco.com'];
const WTW_NOVA_HOSTNAMES = Object.freeze([
  'nova.wtwco.com',
  'us-nova.wtwco.com',
  'stage-nova.wtwco.com',
  'stage-us-nova.wtwco.com',
  ...EU_WTW_NOVA_HOSTNAMES,
  'nova.stage.eu.newfront-development.com',
]);

function normalizeHostname(hostname) {
  return hostname.trim().toLowerCase().replace(/:\d+$/, '');
}

function getHostnameRegion(hostname) {
  const normalized = normalizeHostname(hostname);
  return EU_WTW_NOVA_HOSTNAMES.includes(normalized) ||
    normalized.endsWith('.eu.newfront.com') ||
    normalized.endsWith('.eu.newfront-development.com')
    ? 'eu'
    : 'us';
}

function getDeploymentRegion(value) {
  const region = (value || 'us').trim().toLowerCase();
  if (region !== 'us' && region !== 'eu') {
    throw new Error(`Unsupported NEWFRONT_REGION: "${value}". Expected "us" or "eu".`);
  }
  return region;
}

function isWtwNovaHostname(hostname) {
  return hostname != null && WTW_NOVA_HOSTNAMES.includes(normalizeHostname(hostname));
}

module.exports = { WTW_NOVA_HOSTNAMES, getHostnameRegion, getDeploymentRegion, isWtwNovaHostname };
